import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d36ad66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "summary" }
const _hoisted_2 = { class: "summary-text-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Din order med ordernummer:")
], -1))
const _hoisted_4 = { class: "code" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "har skapats.")
], -1))

import ContentWrapper from "@/components/generics/ContentWrapper.vue";
import { useBookingStore } from "@/store/bookingStore";
import CustomTable from "@/components/generics/CustomTable.vue";
import ticket from "@/types/ticket";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmationView',
  setup(__props) {

const bookingStore = useBookingStore();

var orderinfo = [
  {
    Namn: bookingStore.order.firstname + " " + bookingStore.order.surname,
    Email: bookingStore.order.email,
    Telefon: bookingStore.order.phoneNumber,
    Adress: `${bookingStore.order.adress},${bookingStore.order.postalNumber}, ${bookingStore.order.city}`,
  },
];

var ticketinfo = [
  ...bookingStore.shoppingCart.map((ticket: ticket) => {
    return {
      Pass: ticket.type,
      Komfort: `${ticket.comfort}, ${ticket.age}`,
      Resenär: `${ticket.firstName} ${ticket.lastName}`,
      Aktiveringskod: ticket.mobileActivationCode,
    };
  }),
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ContentWrapper, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(bookingStore).order.eurailOrderNumber), 1),
          _hoisted_5
        ]),
        _createVNode(CustomTable, { "table-items": _unref(orderinfo) }, null, 8, ["table-items"]),
        _createVNode(CustomTable, { "table-items": _unref(ticketinfo) }, null, 8, ["table-items"])
      ])
    ]),
    _: 1
  }))
}
}

})